/* eslint-disable react/prop-types */
import React from 'react';
import { View, Text, TouchableOpacity } from 'react-native';

function SwitcherDropdown({
  testIDPrefix,
  buttonStyle,
  buttonContent,
  arrowIcon,
  isOpen,
  onToggle,
  options,
  dropdownStyle,
  optionStyle,
  optionTextStyle,
  disabledOptionTextStyle,
}) {
  return (
    <TouchableOpacity
      testID={`${testIDPrefix}-btn`}
      onPress={onToggle}
      style={buttonStyle}
      activeOpacity={isOpen ? 1 : 0.6}>
      {buttonContent}
      {arrowIcon}
      {isOpen ? (
        <View testID={`${testIDPrefix}-dropdown`} style={dropdownStyle}>
          {options.map((option) => (
            <TouchableOpacity
              testID={option.testID}
              key={option.key}
              activeOpacity={option.disabled ? 1 : 0.9}
              disabled={option.disabled}
              onPress={() => option.onSelect(option.key)}
              style={optionStyle}>
              {option.icon}
              <Text
                style={
                  option.disabled ? disabledOptionTextStyle : optionTextStyle
                }>
                {option.label}
              </Text>
            </TouchableOpacity>
          ))}
        </View>
      ) : null}
    </TouchableOpacity>
  );
}

export default SwitcherDropdown;
